<template>
  <router-view ></router-view>
</template>

<script>
  export default {
    name: "import-add-wrapper"
  }
</script>

<style scoped>

</style>
